/* DANYCARE: Mega-Menü auf Desktop per Hover öffnen/schließen.
   Klick (Touch, Tastatur, Screenreader) bleibt über Dawns details/summary
   vollständig erhalten — das hier ist nur eine Maus-Abkürzung. */
(function () {
  if (!window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('header-menu > details.mega-menu').forEach(function (details) {
    var host = details.closest('header-menu');
    var closeTimer;

    host.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    host.addEventListener('mouseleave', function () {
      // kleine Toleranz gegen Flackern beim Überstreichen benachbarter Punkte
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 120);
    });
  });
})();
